
export default function ChevronRightFilled() {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='check-filled'>
        <path
          id='Vector'
          d='M9.99573 18.3259C14.5549 18.3259 18.3327 14.5554 18.3327 9.9962C18.3327 5.43702 14.5477 1.6665 9.98847 1.6665C5.43327 1.6665 1.66602 5.43702 1.66602 9.9962C1.66602 14.5554 5.44052 18.3259 9.99573 18.3259ZM9.08664 14.0024C8.83564 14.0024 8.63794 13.9055 8.44424 13.6505L6.29271 11.0374C6.17809 10.8977 6.11754 10.733 6.11754 10.5684C6.11754 10.235 6.36781 9.9695 6.70188 9.9695C6.90936 9.9695 7.07404 10.0373 7.2467 10.2746L9.05436 12.5413L12.712 6.72077C12.8444 6.49804 13.0341 6.38342 13.2278 6.38342C13.5507 6.38342 13.8412 6.60141 13.8412 6.94276C13.8412 7.10092 13.7549 7.27284 13.6613 7.41324L9.69276 13.6505C9.53535 13.8877 9.33039 14.0024 9.08664 14.0024Z'
          fill='#1F2647'
        />
      </g>
    </svg>
  );
}
